export const VIEW_TYPE_WIDGET = 'widget';
export const VIEW_TYPE_PLATFORM = 'platform';
